<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFolderRemoveOutline } from "@mdi/js";
export default {
  name: "MdiFolderRemoveOutline",
  data() {
    return {
      svgPath: mdiFolderRemoveOutline,
    };
  },
};
</script>
